import { ParentBusiness, CommonService } from 'fccore2';
import { Observable } from 'rxjs';
import { FcEvent } from './fcevent.event';
/**
 * éèé¡¶é¨èåï¼éå·åé
 * @param menus éèé¡¶é¨èåï¼éå·åé
 */
export function fcnavbarInvisible(menus: string) {
    CommonService.event(FcEvent.fcnavbar.fcnavbarInvisible, menus);
}
/**
 * æ ¹æ®å½åäº§ååå½ååä½åtokenè·åç¨æ·çèåæ å½¢ç»æ
 * @param pid äº§åid
 * @param scompanyCode å½ååä½
 */
export function fcnavbarFindMenusByToken(pid: string, scompanyCode: string): Observable<any> {
    const url = CommonService.getUrlBy('SYSTEM', 'SYSMENU', 'getMenuByToken');
    return ParentBusiness.daoService.getFromApi(url, { P_PID: pid, P_MENUID: '', SCOMPANY_CODE: scompanyCode });
}
/**
 * æ¾ç¤ºé¡¶é¨èåï¼éå·åé
 * @param menus æ¾ç¤ºé¡¶é¨èåï¼éå·åé
 */
export function fcnavbarVisible(menus: string): void {
    CommonService.event(FcEvent.fcnavbar.fcnavbarVisible, menus);
}
/**
 * çå¬æ¾ç¤ºé¡¶é¨èåï¼éå·åé
 * @param menus æ¾ç¤ºé¡¶é¨èåï¼éå·åé
 */
export function fcnavbarsetMenushoworhide(menus: any[], menuIds: string, isShow: boolean): any {
    if (menus) {
        menus.forEach(menu => {
            if (menuIds && menuIds.indexOf(menu.MENUID) !== -1) {
                menu.HIDDEN = isShow;
            }
            if (menu.P_CHILDMENUS && menu.P_CHILDMENUS.length > 0) {
                fcnavbarsetMenushoworhide(menu.P_CHILDMENUS, menuIds, isShow);
            }
        });
    }
}
